module.exports = __webpack_public_path__ + "img/7041212.png";